<template>
  <v-container fluid grid-list-lg mb-3>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <h2 class="heading-2 align-left">Personal Information</h2>

        <v-alert :value="true" v-if="error != null" type="error">{{ error.message }}</v-alert>
        <v-alert :value="true" v-if="ticketMessage != null" type="info" color="blue-grey">{{ ticketMessage}}</v-alert>
        <v-alert :value="true" v-if="success != null" type="success">{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-form ref="form" v-model="valid" @submit="updateUser">
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="firstName"
                    :rules="firstNameRules"
                    label="First Name *"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="lastName"
                    :rules="lastNameRules"
                    label="Last Name *"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="username"
                    :rules="usernameRules"
                    readonly
                    label="Email *"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="phoneNumber"
                    :rules="phoneRules"
                    label="Mobile Phone Number"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <p class="dob">Date of Birth <span class="dobChange" v-if="this.configValues.accountDoBUpdatesAllowed === false">(Please email the club to update your date of birth)</span></p>
              <v-layout row>
                <v-flex xs12 sm4>
                  <v-select
                    :items="days"
                    label="DD"
                    v-model="dobDay"
                    :rules="dobRules"
                    :readonly="this.configValues.accountDoBUpdatesAllowed === false"
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    :items="months"
                    label="MM"
                    v-model="dobMonth"
                    :rules="dobRules"
                    outline
                    :readonly="this.configValues.accountDoBUpdatesAllowed === false"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    :items="years"
                    label="YYYY"
                    v-model="dobYear"
                    :rules="dobRules"
                    outline
                    :readonly="this.configValues.accountDoBUpdatesAllowed === false"
                  ></v-select>
                </v-flex>
              
              </v-layout>
              <v-layout row v-if="this.configValues.accountGenderRequested === true">
                <v-flex xs12>
                  <v-select
                    :items="this.configValues.accountGenderList"
                    label="Gender"
                    v-model="gender"
                    outline
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row>
                <h3 class="heading-3 align-left address-align">Address</h3>
              </v-layout>
              <v-layout row>
                <p
                  class="address-align"
                >In order to provide online ticketing purchasing functionality we require your primary billing address.</p>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field
                    outline
                    v-model="address1"
                    :rules="addressRules"
                    label="Address line 1*"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field outline v-model="address2" :rules="addressRules" label="Address line 2*" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field outline v-model="address3" label="Address line 3" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field outline v-model="locality" :rules="addressRules" label="City / Town*" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field outline v-model="region" label="County / Region" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field
                    outline
                    v-model="postal_code"
                    :rules="addressRules"
                    label="Postal Code*"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-select outline :items="countries" v-model="country" item-text="name" :rules="addressRules" label="Country*" required></v-select>
                </v-flex>
              </v-layout>
              
              <v-layout row align-center mx-1>
                <v-spacer />
                <button
                  type="submit"
                  class="button"
                  :disabled="!valid || !ready"
                  color="success"
                >{{saveButtonText}}</button>
              </v-layout>
            </v-form>
          </template>

          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular :size="50" color="accent" indeterminate></v-progress-circular>
            </div>
          </template>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "UserProfile",
  data() {
    return {
      ready: false,
      valid: true,
      firstNameRules: [v => !!v || "First name is required"],
      lastNameRules: [v => !!v || "Last name is required"],
      usernameRules: [
        v => !!v || "Email address is required",
        v => /.+@.+/.test(v) || "Email must be valid"
      ],
      dobRules: [
        v => !!v || "Date of Birth is required",
        v => (this.dobYear+'-'+("0" + this.dobMonth).slice(-2)+'-'+("0" + this.dobYear).slice(-2)).toString() < new Date().toISOString().split('T')[0] || "Date can't be in the future"
      ],
      addressRules: [v => !!v || "You must fill in this address field"],
      ssoid: '',
      firstName: "",
      lastName: "",
      phoneNumber: "",
      username: "",
      gender: "",
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      originalEmail: "",
      error: null,
      ticketMessage: null,
      success: null,
      loading: false,
      address: null,
      address1: "",
      address2: "",
      address3: "",
      locality: "",
      region: "",
      postal_code: "",
      country: "",
      countries: [],
      genderOptions: ['','Female', 'Male','Prefer not to say','Other'],
      days: [],
      months: [],
      years: [],
      saveButtonText: 'Save Details'
    };
  },
  created() {
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe(
      userData => {
        // console.log(userData)
        console.log("getting user attributes");
        this.ssoid = userData['sub']
        this.username = userData.email;
        this.firstName = userData.given_name;
        this.lastName = userData.family_name;
        this.phoneNumber = userData.phone_number;
        this.phoneNumber = userData.phone_number;
        this.originalEmail = userData.email;
        this.gender = userData.gender;

        if (userData.birthdate) {
          var birthdayDates = userData.birthdate.split("-");
          this.dobDay = parseInt(birthdayDates[2]);
          this.dobMonth = parseInt(birthdayDates[1]);
          this.dobYear = parseInt(birthdayDates[0]);
        }

        if (userData["address"]) {
          this.address = JSON.parse(userData["address"]);
          if (this.address) {
            console.log(
              "Address",
              typeof this.address["street_address"],
              this.address["street_address"]
            );
            //set our address fields
            if (this.address["street_address"]) {
              var addressFields = this.address["street_address"].split("\n");
              this.address1 = addressFields[0];
              this.address2 = addressFields[1];
              this.address3 = addressFields[2];
            }
            this.locality = this.address.locality;
            this.region = this.address.region;
            this.postal_code = this.address.postal_code;
            this.country = this.address.country;
          }
        }
        fetch("/countries.json")
          .then(r => r.json())
          .then(
            json => {
              this.countries = json.countries;
            },
            response => {
              console.log("Error loading json:", response);
            }
          );

        // tell the app that we've finished loading
        this.ready = true;
      },
      err => {
        console.log("Unable to load user profile, session may not be present.");
      }
    );
  },
  watch: {
    dobDay: function (val, oldVal) {
      if(typeof this.$refs.form !== 'undefined'){
        this.$refs.form.validate()
      }
    },
    dobMonth: function (val, oldVal) {
      if(typeof this.$refs.form !== 'undefined'){
        this.$refs.form.validate()
      }
    },
    dobYear: function (val, oldVal) {
      if(typeof this.$refs.form !== 'undefined'){
        this.$refs.form.validate()
      }
    }
  },
  /*watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate()
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate()
    }
  },*/
  computed: {
    phoneRules() {
      //alert(this.phoneNumber)
      if (!this.phoneNumber) {
        return [];
      } else {
        return [
          v =>
            /^$|^\+(?:[0-9] ?){6,14}[0-9]$/.test(v) ||
            "Phone number must be valid and contain international dail code e.g. +447891234567"
        ];
      }
    }
  },
  mounted() {
    this.populateDates();
    if(typeof localStorage.returnUrl != 'undefined'){
      if(localStorage.loginFlow == "AddressRequired"){
        this.ticketMessage = this.getPlatformRequiresAddressMessage()
        this.saveButtonText = this.getPlatformRequiresAddressButton()
      } else if(localStorage.loginFlow == "TicketMasterNoClientRef"){
        this.saveButtonText = 'Save and visit ticketing'
        this.ticketMessage = 'To purchase tickets you must first use the Link Client Reference option to create a link with the ticketing platform. You can then click \'' + this.saveButtonText +'\' to return to the ticket platform.'
        
      } else if(localStorage.returnUrl.includes('ticket')){
        this.ticketMessage = 'Please update your details to ensure they are up to date. Upon clicking \'Confirm Details\' you will be returned to the ticketing platform'
        this.saveButtonText = 'Confirm Details'
      }
    }
  },
  methods: {
    pad(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },
    populateDates() {
      console.log("ADDING DATES");
      for (var d = 1; d < 32; d++) {
        this.days.push(d);
      }
      for (var m = 1; m < 13; m++) {
        this.months.push(m);
      }
      var thisYear = new Date().getFullYear();
      for (var y = thisYear + 1; y > 1900; y--) {
        this.years.push(y);
      }
    },
    redirectUser(e) {
      if (localStorage.returnUrl) {
        var redirectLocation = localStorage.returnUrl.substring(8).split('.')[0];
        var redirectAlert = '';
        // if they were from a trusted referrer and we need to send them back with a JWT
        if (redirectLocation === 'shop' || redirectLocation === 'stage-shop') {
          redirectAlert = 'You are being redirected to the Online Store'
        } else if (redirectLocation === 'tickets') {
          redirectAlert = 'You are being redirected to the Ticketing website'
        } else if (redirectLocation === 'video') {
          redirectAlert = 'You are being redirected to UZ TV'
        } else if (redirectLocation === 'rewards') {
          redirectAlert = 'You are being redirected to the Rewards website'
        } else {
          redirectAlert = 'You are being redirected to the referring platform'
        }
        alert(redirectAlert)
        var authUser = this.$getAuthenticatedUser();
        authUser.getSession(function(err, session) {
          // console.log ('jwtToken', session.getIdToken().getJwtToken())
          var jwtToken = session.getIdToken().getJwtToken();
          if(localStorage.responseType == "post"){
            console.log('post based redirect being performed')
            var form = document.createElement('form');
            document.body.appendChild(form);
            form.method = 'post';
            form.action = localStorage.returnUrl;
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'token';
            input.value = jwtToken;
            form.appendChild(input);
            console.log('performing redirect post submit to ', localStorage.returnUrl)
            localStorage.removeItem('returnUrl');
            localStorage.removeItem('suppressToken');
            localStorage.removeItem('responseType');
            localStorage.removeItem('loginFlow');
            form.submit();
          } else {
            console.log('standard (get) redirect being performed (2)')
            var firstQueryChar = '?' 
            if(localStorage.returnUrl.includes('?')){ // account for ? in string
              firstQueryChar = '&'  
            }
            var redirect = localStorage.returnUrl 
            if(!localStorage.suppressToken){
              redirect = redirect + firstQueryChar + 'token=' + jwtToken
            }
            console.log('redirecting to ' + redirect)
            localStorage.removeItem('returnUrl');
            localStorage.removeItem('suppressToken');
            localStorage.removeItem('responseType');
            localStorage.removeItem('loginFlow');
            window.location = redirect
          }
        });
      }
    },
    crmXCMPush(username){
      var crmXCMPushURL = process.env.VUE_APP_XCM_CRM_API+'/user/push/'+ username
      console.log('XCM push url', crmXCMPushURL)
      return axios({
        method: 'get',
        url: crmXCMPushURL
      })
    },
    complete(username){
      console.log('completing')
      var vm = this
      this.dataPush(username)
      .then(function (results) {
        vm.error = null
        var response = {"message": 'Your details have been updated successfully.'}
        vm.success = response
        vm.ready = true

        vm.$getSession().subscribe(
        sessionData => {
          console.log("Session data", sessionData);
          // Post Data to SeatGeek's server (using the id Token)
          setTimeout(function() {
            var lastSub = vm.$cookie.get(
              `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`
            );
            var idToken = vm.$cookie.get(
              `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`
            );
            axios
              .post(`${process.env.VUE_APP_SEATGEEK_SRO_ENDPOINT}`, idToken)
              .then(function(seatGeekResponse) {
                // Tell our parent window that the profile has been updated (if one exists)
                if (window.opener) {
                  console.log("sending profileUpdated postMessage");
                  window.opener.postMessage("profileUpdated", "*");
                }
                vm.redirectUser();
              })
              .catch(function(error) {
                // Tell our parent window that the profile has been updated (if one exists)
                if (window.opener) {
                  console.log("sending profileUpdated postMessage");
                  window.opener.postMessage("profileUpdated", "*");
                }
                vm.redirectUser();
              });
          }, 500);
        });
      });
    },
    updateUser(e) {
      e.preventDefault()
      this.ready = false

      var email = this.username
      var firstName = this.firstName
      var lastName = this.lastName
      var phoneNumber = this.phoneNumber
      var gender = this.gender

      var attributesList = {
        given_name: firstName,
        family_name: lastName,
        phone_number: phoneNumber,
        gender: gender
      };

      var street_address =
        this.address1 + "\n" + this.address2 + "\n" + this.address3

      var address = {
        street_address: street_address,
        locality: this.locality,
        region: this.region,
        postal_code: this.postal_code,
        country: this.country
      };

      if(this.configValues.accountDoBUpdatesAllowed === true) {
        if(this.dobDay && this.dobMonth && this.dobYear){
          attributesList['birthdate'] = this.dobYear + '-' + this.pad(this.dobMonth, 2) + '-' + this.pad(this.dobDay, 2)
        }
      }

      attributesList["address"] = JSON.stringify(address);

      if (this.originalEmail.toLowerCase() != email.toLowerCase()) {
        attributesList["email"] = email;
        // trigger verification workflow
      }
      var vm = this
      this.$updateAttributes(attributesList).subscribe(response => {
          console.log("update successful")
          vm.complete(this.ssoid)  
        },
        err => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          // console.log(err.message)
          this.success = null;
          this.error = err;
          this.ready = true;
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.address-align {
  margin-left: 20px;
}

.dob {
    /* margin: 0 0 1.25em; */
  color: $core-grey;
  font-size: 15px;
  line-height: 22px;
}
.dobChange {
  font-size: 11px;
}

</style>